import { render } from "./ProductUnitsSearch.vue?vue&type=template&id=2fae46c9&scoped=true"
import script from "./ProductUnitsSearch.vue?vue&type=script&lang=js"
export * from "./ProductUnitsSearch.vue?vue&type=script&lang=js"

import "./ProductUnitsSearch.vue?vue&type=style&index=0&id=2fae46c9&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fae46c9"]])

export default __exports__